"use strict";
/**
 * Contains some common type definitions and typebox helpers.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonT = exports.dateT = void 0;
exports.assertNever = assertNever;
exports.assertIsJsonObject = assertIsJsonObject;
exports.Nullable = Nullable;
const typebox_1 = require("@sinclair/typebox");
/**
 * Typescript helper for verifying a type has been refined to never. Useful
 * for enums and discriminated unions to verify all cases are covered.
 *
 * At runtime, if called, it will call the optional fallback function and
 * then return undefined.
 *
 * @param value {never} The value to assert as never in Typescript.
 * @param fallback [function] The fallback function to call.
 * @returns {never}
 */
function assertNever(_value, fallback) {
    typeof fallback === "function" && fallback();
    return void 0;
}
/**
 * Returns true or false based on whether the passed JsonValue is an object.
 * Typescript can use the return for type refinement.
 *
 * @param value {JsonValue} The value to assert as JsonValue in Typescript
 * @returns {boolean}
 */
function assertIsJsonObject(value) {
    return !!value && !Array.isArray(value) && typeof value === "object";
}
/**
 * Typebox helper for a type that can be one thing or null.
 */
function Nullable(t) {
    return typebox_1.Type.Union([typebox_1.Type.Null(), t]);
}
/**
 * Typebox Date type using the Type.Unsafe machinery.
 */
exports.dateT = typebox_1.Type.Unsafe({
    type: "object",
    customObjectType: "dateT",
});
/**
 * Typebox Json type using the Type.Unsafe machinery.
 */
exports.jsonT = typebox_1.Type.Unsafe(typebox_1.Type.Any());
//# sourceMappingURL=Types.js.map